export const ACTIVE_INTERACTION_COLOR = 0x0d6efd;
export const HOVER_LONG_PRESS_MS = 450;

export const supportsHover = (pointerType: string): boolean =>
    pointerType === "mouse" || pointerType === "pen";
